export default __webpack_public_path__ + "static/7-f76d0fabbe7f35ba3dea93aabe7f67a9.jpg";